<template>
    <f7-popup tablet-fullscreen ref="popupListadoTareas" class="popup-listado-tareas" :opened="true"
        @popup:opened="onPopupOpened" @popup:closed="onPopupClosed" swipe-to-close>
        <f7-page>
            <f7-navbar :title="getPopupTitle()">
                <f7-nav-right></f7-nav-right>
            </f7-navbar>
            <f7-card class="elevation-3 padding-vertical-half padding-right">
                <!-- rList Table CARD-->
                <r-dynamic-list 
                    ref="rlist" 
                    :dbAdapter="Tarea" 
                    :tableCode="tableCode" 
                    :primary="['id']"
                    :tableMode="true" 
                    :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
                    class="card full-height data-table"
                    classContent="card-content full-height"
                    :shownFields="shownFields" 
                    :massiveActions="false" 
                    :mandatoryFilter="getFilter()"
                    :funcShowCheck="_ => { return false; }" 
                    :controlsWidth="60" 
                    :searchOnInit="true">
                    <template v-slot:optionsColumn="{ item }">
                        <f7-link icon-f7="eye" color="green" @click="verTarea(item)"></f7-link>
                        <f7-link icon-f7="square_pencil" color="blue" @click="editarTarea(item)"></f7-link>
                    </template>
                </r-dynamic-list>
            </f7-card>
        </f7-page>
    </f7-popup>
</template>
<style scoped>
/* Estilos específicos para el popup de tareas - sin interferir con responsive */
.popup-listado-tareas .data-table {
    width: 100%;
}

/* Resetear estilos que pueden estar causando problemas */
.popup-listado-tareas .data-table .line {
    display: table-row !important;
    height: auto !important;
    white-space: normal !important;
}

.popup-listado-tareas .data-table .cell {
    display: table-cell !important;
    vertical-align: middle !important;
}

/* Columna de opciones sin posición sticky para evitar conflictos */
.popup-listado-tareas .data-table .right-column-sticky {
    width: 60px !important;
    min-width: 60px !important;
    text-align: center !important;
}
</style>
<script>
import rDynamicList from "./rDynamicList.vue";
import Tarea from "./../js/db/Tarea.js";

export default {
    components: {
        rDynamicList
    },
    data() {
        return {
            Tarea,
            popupOpened: false,
        };
    },
    props: {
        filterName: {
            type: String,
            default: "codigoFactura"
        },
        filterValue: {
            type: String,
            default: null
        },
        entityField: {
            type: String,
            default: "facturas.codigo"
        },
        tableCode: {
            type: String,
            default: "TAREASFACTURA"
        },
        shownFields: {
            type: Array,
            default: () => ['facturas']
        }
    },
    computed: {},
    methods: {
        getPopupTitle() {
            const self = this;
            // Extraer el nombre de la entidad del entityField (ej: "facturas.codigo" -> "factura")
            if (self.entityField.includes('.')) {
                const [entityPlural] = self.entityField.split('.');
                // Convertir plural a singular (simple: quitar 's' al final)
                const entitySingular = entityPlural.endsWith('s') ? entityPlural.slice(0, -1) : entityPlural;
                return `Tareas de la ${entitySingular} ${self.filterValue}`;
            }
            return `Tareas filtradas por ${self.filterName}: ${self.filterValue}`;
        },
        getFilter() {
            const self = this;
            
            // Detectar si es un filtro de entidad anidada (ej: facturas.codigo, oportunidades.id, etc.)
            if (self.filterName.includes('.')) {
                const [entityField, fieldName] = self.filterName.split('.');
                
                return {
                    historificar: true,
                    andList: [{
                        historificar: true,
                        nombre: `${entityField}.${fieldName}`,
                        valor: self.filterValue,
                        operacion: self.getOperationForField(fieldName)
                    }]
                };
            }
            
            // Para filtros simples (sin punto)
            return {
                historificar: true,
                andList: [{
                    historificar: true,
                    nombre: self.filterName,
                    valor: self.filterValue,
                    operacion: self.getOperationForField(self.filterName)
                }]
            };
        },

        getOperationForField(fieldName) {
            // Determinar la operación según el tipo de campo
            const numericFields = ['numero', 'id', 'importe', 'cantidad'];
            const exactMatchFields = ['codigo', 'estado', 'tipo'];
            
            if (numericFields.some(field => fieldName.toLowerCase().includes(field))) {
                return 'EQUALS';
            }
            if (exactMatchFields.some(field => fieldName.toLowerCase().includes(field))) {
                return 'EQUALS_IGNORE_CASE';
            }
            
            // Por defecto, usar CONTAINS para búsquedas más flexibles
            return 'CONTAINS_IGNORE_CASE';
        },
        verTarea(item) {
            const self = this;
            // Navegar a la vista de la tarea
            var currentUrl = new URL(window.location.href);
            var tareaUrl = currentUrl.pathname + ('#!/' + `tarea/view/${item.id}/`);
            window.open(tareaUrl, '_blank');
        },
        editarTarea(item) {
            const self = this;
            // Navegar a la edición de la tarea
            var currentUrl = new URL(window.location.href);
            var tareaUrl = currentUrl.pathname + ('#!/' + `tarea/edit/${item.id}/`);
            window.open(tareaUrl, '_blank');
        },
        onPopupOpened: function (e) {
            var self = this;
            var app = self.$f7;
            self.popupOpened = true;
            this.$emit('listado-abierto', true);
        },
        onPopupClosed: function (e) {
            var self = this;
            var app = self.$f7;
            this.$emit('listado-cerrado', true);
        },
    },
    mounted: function () {
        var self = this;
        var app = self.$f7;
    }
};
</script>
